import styled from "@emotion/styled";
import { Button, LoadingIndicator } from "@sunrun/experience-ui-components";
import { useCallback, useState } from "react";
import { CommandMasquerade } from "messages";
import { EVENT_BUS } from "adapters/common";

const Masquerade = () => {
  const [masqueradeContactId, setMasqueradeContactId] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const onClick = useCallback(() => {
    const message = {
      type: "COMMAND:MASQUERADE",
      source: "Container",
      payload: {
        masqueradeContactId: masqueradeContactId,
      },
    } as CommandMasquerade;
    EVENT_BUS.emit("COMMAND:MASQUERADE", message);
    setIsSubmitted(true);
  }, [masqueradeContactId]);
  return (
    <ContainerDiv>
      <div>
        <label>
          Salesforce Contact ID:
          <input
            name="masquerade-contact-id"
            value={masqueradeContactId}
            onChange={(e) => setMasqueradeContactId(e.target.value)}
          />
        </label>
      </div>
      {!isSubmitted && (
        <Button size="sm" onClick={onClick}>
          Masquerade
        </Button>
      )}
      {isSubmitted && <LoadingIndicator color="black"></LoadingIndicator>}
    </ContainerDiv>
  );
};

const ContainerDiv = styled.div`
  padding: 2rem;
`;

export { Masquerade };
